module.exports = __webpack_public_path__ + "static/img/act_text_02.0d24fa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleFestival/3/act_text_02.png
// module id = 1s+s
// module chunks = 1